import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  headingTitle: {
    id: 'course-authoring.import.file-section.title',
    defaultMessage: 'Select a .tar.gz file to replace your course content',
  },
  fileChosen: {
    id: 'course-authoring.import.file-section.chosen-file',
    defaultMessage: 'File chosen: {fileName}',
  },
});

export default messages;
